module.exports = __webpack_public_path__ + "img/XAI2.536d679b.jpg";